export default { // 该需求运行在销售app、评估师app、合伙人app;销售app：消息->公告通知->详情
  tabs: [
    {
      name: 'message',
      path: '/message',
      component: () => import('./src/message.vue'),
      meta: {
        title: '消息详情',
        isMenu: true,
        rule: 'message'
      }
    }
  ]
}
